<template>
  <left-box-element>
    <template #element-title>
      <h1>{{ $t("helpdesk.landingPage.typeSectionTitle") }}</h1>
    </template>

    <template #element-content>
      <el-container
        v-if="!tableData.length"
        v-loading="isLoading"
        class="landing-page-element-body loading-box"
      />
      <transition name="el-fade-in-linear">
        <el-container
          v-if="tableData.length"
          v-loading="isLoading"
          class="landing-page-element-body"
        >
          <el-main class="table-box">
            <el-table
              :data="tableData"
              stripe
              border
              size="small"
              header-row-class-name="type-of-requests-table"
            >
              <el-table-column
                v-for="(column, index) in typeOfRequestsTableColumns"
                :key="index"
                :prop="column"
                :label="column"
                :class-name="column === 'total' ? 'total-column' : ''"
                align="center"
              />
            </el-table>
          </el-main>
        </el-container>
      </transition>
    </template>
  </left-box-element>
</template>

<script lang="ts">
import { Vue, Component, Watch } from 'vue-property-decorator'

import LeftBoxElement from '@/components/Helpdesk/LandingPage/LeftBoxElement.vue'

import {
  TicketsStatisticsQuery,
  Maybe
} from '@/types/graphql'

type TagCount = NonNullable<TicketsStatisticsQuery['ticketsStatistics']['tag_counts'][0]>

@Component({
  components: {
    LeftBoxElement
  }
})
export default class extends Vue {
  private isLoading = false

  private typeOfRequestsTableColumns: any = []

  private tableData: any = []

  private typeOfRequestsTableData(tagCount: Array<Maybe<TagCount>>) {
    let totalTickets = 0
    const countRow = {}
    const percentageRow = {}

    tagCount = tagCount.map(element => {
      return {
        tag_name_tickets: ((element as TagCount).tag_name_tickets),
        tag_count_tickets: (element as TagCount).tag_count_tickets
      }
    })

    tagCount.forEach(element => {
      totalTickets += (element as TagCount).tag_count_tickets
    })

    tagCount.forEach(element => {
      Vue.set(countRow, (element as TagCount).tag_name_tickets, (element as TagCount).tag_count_tickets)
      Vue.set(percentageRow, (element as TagCount).tag_name_tickets, Math.round((100 * (element as TagCount).tag_count_tickets) / totalTickets) + '%')
    })

    Vue.set(countRow, 'Total', totalTickets)

    this.typeOfRequestsTableColumns = Object.keys(countRow).map((key) => { return key })

    Vue.set(percentageRow, 'Total', '100%')

    this.tableData.push(countRow, percentageRow)
  }

  private async getTicketStatisticsQuery() {
    this.isLoading = true
    this.$apollo
      .query({
        query: TicketsStatisticsQuery,
        fetchPolicy: 'network-only'
      })
      .then(res => {
        this.tableData = []
        this.typeOfRequestsTableData(res.data.ticketsStatistics.tag_counts)
      })
      .finally(() => {
        this.isLoading = false
      })
  }

  created() {
    this.getTicketStatisticsQuery()
  }

  @Watch('$i18n.locale')
  private languageChanged() {
    this.getTicketStatisticsQuery()
  }
}
</script>
